module.exports = __webpack_public_path__ + "img/service-desc-bg.f2ad8b02.webp";